export const getRoundedFactor = factor => {
  const factorValue = Number(factor);
  const factorDecAmount = factorValue.toString().split('.')[1]?.length;
  if (!factorDecAmount || factorDecAmount < 2) return factorValue.toFixed(2);
  if (factorDecAmount < 9) return factorValue.toFixed(factorDecAmount);
  return factorValue.toFixed(9);
};
